import {HttpClient} from '../../../api/httpClient' 
import {API_URL} from '../../../api/RestAPI'
import apiHeaders from '../../../api/apiHeaders'
import {setUrlForGetRequest} from '../../../api/sharedFunctions'

//Setting the store API URI
const STORE_API = `${API_URL}/stores`
const CURRENCY_API = `${API_URL}/currencies`

const getCurrencies = () => {
  return HttpClient.get(
    `${CURRENCY_API}/`,
    apiHeaders()
  )
}

// Get
const getStore = (id) => {
  return HttpClient.get(`${STORE_API}/${id}`, apiHeaders())
}

// Read
const getStores = (params) => {
  let url = setUrlForGetRequest(STORE_API, params)
  return HttpClient.get(url, apiHeaders())
}

// Update
const updateStore = (id, store) => {
  return HttpClient.put(
    `${STORE_API}/${id}/update`,
    store,
    apiHeaders()
  )
}

const validateStoreUrl = (payload) => {
  return HttpClient.post(
    `${STORE_API}/store-url`,
    payload,
    apiHeaders()
  )
}

// Authenticate Shelfless
const authenticateLogistics = ( storeId, fulfillmentCenterId, applyOnOrderStatus, status = 'active', options = {} ) => {
  const payload = {
    fulfillmentCenterId,
    applyOnOrderStatus,
    status,
    ...('username' in options ? { username: options.username } : {}),
    ...('password' in options ? { password: options.password } : {}),
    ...('auto_stock_sync' in options ? { auto_stock_sync: !!options.auto_stock_sync } : {}),
    ...('auto_tracking_sync' in options ? { auto_tracking_sync: !!options.auto_tracking_sync } : {}),
  };

  return HttpClient.post( `${STORE_API}/${storeId}/authenticate-logistics`, payload, apiHeaders() );
};

const addFulfillmentCenterToStore = (storeId, fulfillmentCenterId) => {
  return HttpClient.post(
    `${API_URL}/stores/${storeId}/add-fulfillment-center`,
    { fulfillment_center_id: fulfillmentCenterId },
    apiHeaders()
  );
};

// Remove fulfillment center from store
const removeFulfillmentCenterFromStore = (storeId, fulfillmentCenterId) => {
  return HttpClient.post(
    `${API_URL}/stores/${storeId}/add-fulfillment-center`,
    { fulfillment_center_id: fulfillmentCenterId, remove: true },
    apiHeaders()
  );
};

const createStoreWithDemo = (payload) => {
  return HttpClient.post(
    `${STORE_API}/create`,
    payload,
    apiHeaders()
  )
}

const duplicateStore = (payload) => {
  return HttpClient.post(
    `${STORE_API}/duplicate`,
    payload,
    apiHeaders()
  )
}

const getStats = (id) => {
  return HttpClient.get(`${STORE_API}/${id}/stats`, apiHeaders())
}

const destroy = (id, force = false) => {
  return HttpClient.delete(`${STORE_API}/${id}${force ? '?force=true' : ''}`, apiHeaders())
}

const restore = (id) => {
  return HttpClient.put(`${STORE_API}/${id}/restore`, {}, apiHeaders());
}

const createStripeAccount = (id, payload = {}) => {
  return HttpClient.post(`${STORE_API}/${id}/stripe-connect`, payload, apiHeaders());
};

const getStripeStatus = (id) => {
  return HttpClient.get(`${STORE_API}/${id}/stripe-status`, apiHeaders());
}

const getStripeDashboardLink = (id) => {
  return HttpClient.get(`${STORE_API}/${id}/stripe-dashboard-link`, apiHeaders());
}

const disconnectStripeAccount = (id) => {
  return HttpClient.post(`${STORE_API}/${id}/stripe-disconnect`, {}, apiHeaders());
};

//Encapsulating in a JSON object
const StoreApi = {getStore, getStores, updateStore, validateStoreUrl, getCurrencies, authenticateLogistics, addFulfillmentCenterToStore, removeFulfillmentCenterFromStore, createStoreWithDemo, duplicateStore, getStats, destroy, restore, createStripeAccount, getStripeStatus, getStripeDashboardLink, disconnectStripeAccount}

export {StoreApi}